import React, { useEffect } from 'react';

import { Message, MessageSender } from '../types/shared';
import History from './History';
import Input from './Input';
import Header from './Header';
import Intro from './Intro';

export interface ChatWindowProps extends MessageSender {
  chatId: string;
  messages: Message[];
  open: boolean;
  isMinimizing: boolean;
  collapsible: boolean;
  onClickMinimize: () => void;
  subscribeToNewMessages: () => void;
}

function ChatWindow(props: ChatWindowProps): JSX.Element {
  const {
    chatId,
    messages,
    open,
    isMinimizing,
    collapsible,
    onClickMinimize,
    subscribeToNewMessages,
    sendMessage,
  } = props;

  useEffect(() => {
    subscribeToNewMessages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Hide chat to maintain user's scroll position after they close
  const chatStyle = {
    display: open ? 'block' : 'none',
  };

  return (
    <div
      className={`Chat${isMinimizing ? ' close' : ''}`}
      style={chatStyle}
      data-testid="chat-window"
    >
      <Header onClickMinimize={onClickMinimize} collapsible={collapsible} />
      <main>
        <Intro sendMessage={sendMessage} chatId={chatId} hidden={!!messages.length} />
        {!!messages.length && (
          <History messages={messages} sendMessage={sendMessage} chatId={chatId} />
        )}
        <Input sendMessage={sendMessage} chatId={chatId} />
      </main>
    </div>
  );
}

export default ChatWindow;
